var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.loadingError && !_vm.isLoading
        ? _c("div", { staticClass: "evaluation-header" }, [
            _c("div", { staticClass: "header-name" }, [
              _c("h2", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.evaluation
                        ? `${_vm.$t(
                            "evaluationTitle"
                          )} de ${_vm.setValueToFormatted(
                            _vm.evaluation.idNumber,
                            "idNumber"
                          )}`
                        : "No se encontró la comprobación"
                    ) +
                    " "
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "header-buttons" },
              [
                _c(
                  "b-button",
                  {
                    staticClass:
                      "is-button-primary ml-2 is-small is-rounded is-pulled-right",
                    attrs: { id: "risk-evaluations-return-button" },
                    on: {
                      click: function ($event) {
                        return _vm.returnToRiskEvaluation()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("backButton")) + " ")]
                ),
                _c(
                  "b-dropdown",
                  {
                    attrs: { "aria-role": "list" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "trigger",
                          fn: function ({ active }) {
                            return [
                              _c("b-button", {
                                attrs: {
                                  id: "risk-evaluations-indicators",
                                  type: "is-primary is-light",
                                  size: "is-small",
                                  label: `Ver indicadores`,
                                  rounded: "",
                                  "icon-right": active
                                    ? "fa fa-chevron-up"
                                    : "fa fa-chevron-down",
                                },
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      503814587
                    ),
                  },
                  [
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: {
                          id: "risk-evaluations-indicators-uf",
                          "aria-role": "listitem",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              `UF: ${_vm.setValueToFormatted(
                                _vm.indicators.uf,
                                "currencyNumber"
                              )}`
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: {
                          id: "risk-evaluations-indicators-utm",
                          "aria-role": "listitem",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              `UTM: ${_vm.setValueToFormatted(
                                _vm.indicators.utm,
                                "currencyNumber"
                              )}`
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.isLoading
        ? _c("Spinner", {
            attrs: { "data-cy": "spinner", "is-loading": _vm.isLoading },
          })
        : !!_vm.loadingError && !_vm.isLoading
        ? _c("Message", {
            attrs: {
              message: _vm.loadingError.message,
              icon: _vm.loadingError.icon,
            },
          })
        : !_vm.calculated
        ? _c(
            "div",
            { staticClass: "card-item evaluation-body" },
            [
              _c("Debtors", {
                attrs: {
                  "extended-debtor": _vm.extendedDebtor,
                  "input-type": _vm.inputType,
                  "feature-toggle-eligibility-button":
                    _vm.featureToggleEligibilityButton,
                  "equifax-pdf-link":
                    _vm.externalProviderDataRequest.equifaxPdfLink,
                },
                on: {
                  "delete-codebtor": function ($event) {
                    return _vm.deleteCodebtor($event)
                  },
                  "set-extended-debtor": function ($event) {
                    return _vm.setExtendedDebtor($event)
                  },
                  "add-input": function ($event) {
                    return _vm.addInput($event)
                  },
                  "update-input": function ($event) {
                    return _vm.updateInput($event)
                  },
                  "delete-input": function ($event) {
                    return _vm.deleteInput($event)
                  },
                  "save-changed-id-number": function ($event) {
                    return _vm.saveChangedIdNumber($event)
                  },
                },
                model: {
                  value: _vm.inputs.debtors,
                  callback: function ($$v) {
                    _vm.$set(_vm.inputs, "debtors", $$v)
                  },
                  expression: "inputs.debtors",
                },
              }),
              _c(
                "b-button",
                {
                  staticClass:
                    "add-codebtor is-button-secondary is-button-second mt-3 mb-3",
                  attrs: { id: "new-codebtor", rounded: "" },
                  on: {
                    click: function ($event) {
                      return _vm.addCodebtor()
                    },
                  },
                },
                [_vm._v(" Agregar codeudor ")]
              ),
              _c(
                "div",
                { staticClass: "options" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "button is-button-fourth is-rounded",
                      attrs: { id: "calculate" },
                      on: {
                        click: function ($event) {
                          return _vm.saveDepuration()
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("refreshButton")))])]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.calculated
        ? _c("div", { staticClass: "card-item evaluation-body" }, [
            _c("div", { staticClass: "details-card" }, [
              _c("div", { staticClass: "details-header" }, [
                _c("span", { staticClass: "content-title" }, [
                  _vm._v(_vm._s(_vm.$t("summary"))),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "card-item-details" },
                [
                  _c("div", { staticClass: "details-header" }, [
                    _c("span", [
                      _c("span", { staticClass: "has-text-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("ufText"))),
                      ]),
                      _c("span", { attrs: { id: "uf-value" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.setValueToFormatted(
                              _vm.summary.uf,
                              "currencyNumber"
                            )
                          ) + " "
                        ),
                      ]),
                    ]),
                    _c("span", [
                      _c("span", { staticClass: "has-text-weight-bold" }, [
                        _vm._v(_vm._s(_vm.$t("utmText")) + " "),
                      ]),
                      _c("span", { attrs: { id: "utm-value" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.setValueToFormatted(
                              _vm.summary.utm,
                              "currencyNumber"
                            )
                          ) + " "
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._l(_vm.summary.debtors, function (debtor) {
                    return _c("div", { key: debtor.debtorIndex }, [
                      _c("div", { staticClass: "details-header" }, [
                        _c(
                          "span",
                          {
                            staticClass: "has-text-weight-bold",
                            attrs: {
                              id: `debtor-${debtor.debtorIndex}-incomeSummary-title`,
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("incomeSummary")) +
                                " " +
                                _vm._s(
                                  debtor.type === "DEBTOR"
                                    ? _vm.$t("debtor")
                                    : `${_vm.$t("codebtor")} ${
                                        debtor.debtorIndex
                                      }`
                                ) +
                                " " +
                                _vm._s(_vm.$t("money")) +
                                ": "
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "title-text",
                            attrs: {
                              id: `debtor-${debtor.debtorIndex}-incomeSummary`,
                            },
                          },
                          [_vm._v(" " + _vm._s(debtor.debtorIncome) + " ")]
                        ),
                      ]),
                      _c("div", { staticClass: "details-header" }, [
                        _c(
                          "span",
                          {
                            staticClass: "has-text-weight-bold",
                            attrs: {
                              id: `debtor-${debtor.debtorIndex}-debtSummary-title`,
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("debtSummary")) +
                                " " +
                                _vm._s(
                                  debtor.type === "DEBTOR"
                                    ? _vm.$t("debtor")
                                    : `${_vm.$t("codebtor")} ${
                                        debtor.debtorIndex
                                      }`
                                ) +
                                " " +
                                _vm._s(_vm.$t("money")) +
                                ": "
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "title-text",
                            attrs: {
                              id: `debtor-${debtor.debtorIndex}-debtSummary`,
                            },
                          },
                          [_vm._v(" " + _vm._s(debtor.debtorDebt) + " ")]
                        ),
                      ]),
                    ])
                  }),
                  _c("div", { staticClass: "details-header" }, [
                    _c(
                      "span",
                      {
                        staticClass: "has-text-weight-bold",
                        attrs: { id: "income-summary-percentage-fixed-title" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("incomeSummaryPercentageFixed")) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "title-text",
                        attrs: { id: "income-summary-percentage-fixed" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.setValueToFormatted(
                                _vm.summary.totalFixed,
                                "currencyNumber"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "details-header" }, [
                    _c(
                      "span",
                      {
                        staticClass: "has-text-weight-bold",
                        attrs: {
                          id: "income-summary-percentage-variable-title",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("incomeSummaryPercentageVariable")) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "title-text",
                        attrs: { id: "income-summary-percentage-variable" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.setValueToFormatted(
                                _vm.summary.totalVariable,
                                "currencyNumber"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "details-header" }, [
                    _c(
                      "span",
                      {
                        staticClass: "has-text-weight-bold",
                        attrs: { id: "income-summary-total-title" },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("incomeSummaryTotal")) + " ")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "title-text",
                        attrs: { id: "income-summary-total" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.setValueToFormatted(
                                _vm.summary.totalIncome,
                                "currencyNumber"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "has-text-weight-bold",
                        attrs: { id: "total-income-uf-title" },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("incomeSummaryTotalUF")) + " "
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "title-text",
                        attrs: { id: "total-income-uf" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.setValueToFormatted(
                                _vm.summary.totalIncomeUf,
                                "currencyNumber"
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "details-header" }, [
                    _c(
                      "span",
                      {
                        staticClass: "has-text-weight-bold",
                        attrs: { id: "debt-summary-total-title" },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("debtSummaryTotal")) + " ")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "title-text",
                        attrs: { id: "debt-summary-total" },
                      },
                      [_vm._v(" " + _vm._s(_vm.summary.totalDebt) + " ")]
                    ),
                  ]),
                  _vm.featureToggleEligibilityButton
                    ? _c("div", [
                        _vm.summary.eligibilityResult
                          ? _c("div", { staticClass: "details-header" }, [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "has-text-weight-bold",
                                    attrs: {
                                      id: "eligibility-summary-total-title",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("eligibilitySummary")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "title-text",
                                    attrs: { id: "eligibility-summary-total" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("trueEligibilitySummary")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "eligibility-summary-reasons" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "has-text-weight-bold",
                                      attrs: {
                                        id: "eligibility-summary-detail-title",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("summaryReasons")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _vm._l(
                                    _vm.summary.detailEligibility,
                                    function (eligibility, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          staticClass: "title-text",
                                        },
                                        [
                                          _c(
                                            "li",
                                            {
                                              attrs: {
                                                id: `eligibility-summary-detail-${index}`,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    Object.values(
                                                      eligibility
                                                    )[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ])
                          : _c("div", [
                              _c("div", { staticClass: "details-header" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "has-text-weight-bold",
                                    attrs: {
                                      id: "eligibility-summary-total-title",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("eligibilitySummary")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "title-text",
                                    attrs: { id: "eligibility-summary-total" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("falseEligibilitySummary")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "has-text-weight-bold",
                                      attrs: {
                                        id: "eligibility-summary-detail-title",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("summaryReasons")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _vm._l(
                                    _vm.summary.detailEligibility,
                                    function (eligibility, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          staticClass: "title-text",
                                        },
                                        [
                                          _c(
                                            "li",
                                            {
                                              attrs: {
                                                id: `eligibility-summary-detail-${index}`,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    Object.values(
                                                      eligibility
                                                    )[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _c("div", { staticClass: "options" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-button-primary is-rounded",
                    attrs: { id: "download-button" },
                    on: {
                      click: function ($event) {
                        return _vm.getDocument()
                      },
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("downloadButton")))])]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }